import Comanda from '../screens/Comanda';

const route = [
  {
    path: '/comanda',
    main: Comanda,
  },
];

export default route;
